import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import mapValues from 'lodash/mapValues';
import { wrapIdbCache, manualSpmReport } from '@alife/workstation-utils';
var PSEUDO_LANG = 'pd_KV';
var GLOBAL_SYMBOL = Symbol.for('MCMS_HELPER_PROMISES');
if (!window[GLOBAL_SYMBOL]) {
  window[GLOBAL_SYMBOL] = {};
}
var promiseCaches = window[GLOBAL_SYMBOL];
var fetchJson = function fetchJson(url) {
  if (!promiseCaches[url]) {
    promiseCaches[url] = fetch(url).then(function (res) {
      return res.json();
    });
  }
  return promiseCaches[url];
};
export var createFetchMcms = function createFetchMcms(options) {
  return wrapIdbCache( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
      var version, tag, appName, mcmsUrl, mcmsInfo, _mcmsInfo$data, _mcmsInfo, result;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            version = _ref.version, tag = _ref.tag, appName = _ref.appName;
            _context.prev = 1;
            if (version) {
              _context.next = 7;
              break;
            }
            _context.next = 5;
            return fetchJson("https://lang.alicdn.com/versioninfo/mcms/".concat(appName, "/").concat(appName).concat(tag ? "_".concat(tag) : '', ".json?t=").concat(Date.now()));
          case 5:
            mcmsInfo = _context.sent;
            mcmsUrl = mcmsInfo === null || mcmsInfo === void 0 ? void 0 : mcmsInfo.urls;
          case 7:
            _context.next = 11;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);
          case 11:
            _context.prev = 11;
            if (!(!version && !mcmsUrl)) {
              _context.next = 17;
              break;
            }
            _context.next = 15;
            return fetchJson("https://mcms-read.alibaba.com/api/openapi/version/info.json?appName=".concat(appName, "&tags=").concat(tag));
          case 15:
            _mcmsInfo = _context.sent;
            mcmsUrl = _mcmsInfo === null || _mcmsInfo === void 0 || (_mcmsInfo$data = _mcmsInfo.data) === null || _mcmsInfo$data === void 0 ? void 0 : _mcmsInfo$data.urls;
          case 17:
            _context.next = 21;
            break;
          case 19:
            _context.prev = 19;
            _context.t1 = _context["catch"](11);
          case 21:
            _context.next = 23;
            return fetchJson(mcmsUrl || "//lang.alicdn.com/mcms/".concat(appName, "/").concat(version, "/").concat(appName).concat(tag ? "_".concat(tag) : '', ".json"));
          case 23:
            result = _context.sent;
            if (result) {
              result[PSEUDO_LANG] = mapValues(result['en_US'] || {}, function (defaultMsg, key) {
                return "##@@@".concat(key, "##").concat(appName, "@@@##").concat(defaultMsg);
              });
            }
            if (!version) {
              // 上报
              manualSpmReport({
                spmc: 'use_mcms',
                spmd: 'no_version',
                data: {
                  pathname: location.pathname,
                  appName: appName,
                  tag: tag
                }
              });
            }
            return _context.abrupt("return", result);
          case 27:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 9], [11, 19]]);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), _objectSpread({
    getCacheKey: function getCacheKey(_ref3) {
      var version = _ref3.version,
        tag = _ref3.tag,
        appName = _ref3.appName;
      return "".concat(appName, "_").concat(tag || '', "_").concat(version);
    }
  }, options));
};

/**
 * @return {number}
 * @param minutes
 */
export function getMinutesTime(minutes) {
  return 1000 * 60 * minutes;
}
export function getHoursTime(minutes) {
  return 1000 * 60 * 60 * minutes;
}